<template>
  <div>
    <nav aria-label="breadcrumb" class="content-block">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#/simpeg-dashboard">Dashboard</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#/cuti-list">Daftar Riwayat Cuti</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#/cuti-setting-list">Daftar Pengaturan Cuti</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          Daftar Hari Libur
        </li>
      </ol>
    </nav>

    <div class="content-block">
      <h5>Daftar Hari Libur</h5>
    </div>
    <LogPopupTemplate ref="logPopup" />

    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <DxDataGrid
          :focused-row-enabled="true"
          ref="dataGrid"
          :data-source="liburListStore.dataSourceLiburList"
          :allow-column-reordering="true"
          :show-borders="true"
          :show-column-lines="false"
          :column-auto-width="true"
          :column-hiding-enabled="false"
          @exporting="onExporting"
          @editing-start="onEditingStart"
          @init-new-row="initNewRow($event)"
          @row-removing="onRowRemoving"
          @row-inserting="onInserting"
          @row-updating="(e) => onUpdating(e)"
          @saved="onSaved"
          @saving="onSaving"
          :word-wrap-enabled="true"
          :height="gridHeight"
          :remote-operations="true"
          :scrolling="{
            mode: 'virtual',
            rowRenderingMode: 'virtual',
            columnRenderingMode: 'virtual',
            useNative: true,
          }"
        >
          <!-- :filter-value="filterValue"
        :filter-sync-enabled="true" -->
          <!-- @selection-changed="onSelectionChanged" -->
          <DxHeaderFilter :visible="true" />

          <DxScrolling mode="virtual" />
          <DxFilterRow :visible="true" apply-filter="auto" />
          <DxPager
            :visible="true"
            :showPageSizeSelector="false"
            :showNavigationButtons="false"
            :show-info="true"
            :infoText="'Page {0} of {1} ({2} items)'"
          />
          <DxPaging :enabled="true" :page-size="numberingPageSize" />
          <DxExport :enabled="true" />
          <DxEditing
            :allow-updating="
              allowUpdate(can('absensi-update'), can('gaji-approve'))
            "
            :allow-deleting="can('absensi-del')"
            :allow-adding="can('absensi-create')"
            :mode="dxEditingMode"
            v-bind="commonFunction.editingConfig(dxEditingMode, 'libur')"
          />
          <!--  -->

          <DxToolbar>
            <DxItem location="after" template="refresh-template" />
            <DxItem name="groupPanel" />
            <DxItem name="addRowButton" show-text="always" />
            <DxItem name="exportButton" />
            <DxItem name="columnChooserButton" />
            <DxItem name="searchPanel" />
          </DxToolbar>
          <template #refresh-template>
            <DxButton
              icon="refresh"
              @click="refreshDatagrid('dataGrid')"
              text="Refresh Data"
              type="default"
              style="float: left"
              width="160px"
              styling-mode="outlined"
            ></DxButton>
          </template>

          <!-- cell-template="diff-cell-template" -->

          <DxColumn
            caption="#"
            data-field="row_number"
            :allow-filtering="false"
            :allow-sorting="false"
            :allow-exporting="false"
            :fixed="true"
            fixed-position="left"
            data-type="number"
          />

          <dx-column
            data-field="id"
            caption="id"
            data-type="number"
            :visible="false"
          />

          <DxColumn
            data-field="tgl"
            caption="Tgl "
            data-type="date"
            :display-format="'dd/MM/yyyy'"
            :format="'dd/MM/yyyy'"
            :allowHeaderFiltering="false"
            :allow-editing="can('absensi-update')"
          >
            <DxRequiredRule />
          </DxColumn>

          <DxColumn
            data-field="tipe"
            caption="Tipe Hari Libur"
            :allowHeaderFiltering="true"
            :header-filter="{
              dataSource: commonStore.tipeHariLiburSource,
            }"
            :allow-filtering="false"
          >
            <DxLookup
              display-expr="nama"
              value-expr="val"
              :data-source="commonStore.tipeHariLiburStore"
            />
            <DxRequiredRule />
          </DxColumn>

          <DxColumn
            data-type="string"
            data-field="nama"
            caption="Nama Hari Libur"
            :allowHeaderFiltering="false"
            :allow-editing="can('absensi-update')"
          >
            <DxRequiredRule />
          </DxColumn>

          <DxColumn
            :allow-hiding="false"
            class="noteditable"
            data-field="ket"
            caption="Keterangan"
            :allowHeaderFiltering="false"
            :allow-editing="can('absensi-update')"
          />

          <DxColumn
            caption="Dibuat oleh"
            :allowHeaderFiltering="false"
            data-field="created_at_text"
            :allowFiltering="false"
            :allow-sorting="false"
            :allow-exporting="false"
            :allow-updating="false"
          />

          <DxColumn
            caption="Diubah oleh"
            :allowHeaderFiltering="false"
            data-field="updated_at_text"
            :allowFiltering="false"
            :allow-sorting="false"
            :allow-exporting="false"
            :allow-updating="false"
          />
          <DxColumn type="buttons" :width="110">
            <DxButtonDataGrid name="edit" />
            <DxButtonDataGrid name="delete" />
            <DxButtonDataGrid
              hint="View Log Perubahan"
              icon="clock"
              :visible="true"
              @click="this.$refs.logPopup.showBySubject($event, 'HariLibur')"
            />
          </DxColumn>
        </DxDataGrid>
      </div>
    </div>
  </div>
</template>

<script>
import LogPopupTemplate from "./LogPopupTemplate.vue";
import auth from "../auth";
import * as commonFunction from "@/utils/common-function.js";
import { useLiburListStore } from "@/stores/views/libur-list-store";
import { useCommonStore } from "@/stores/utility/common-store2";
import { confirm } from "devextreme/ui/dialog";
import can from "@/haspermission";

import DxButton from "devextreme-vue/button";
import DxDropDownButton from "devextreme-vue/drop-down-button";
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxPaging,
  DxFilterRow,
  DxLookup,
  DxPager,
  DxColumnFixing,
  DxExport,
  DxToolbar,
  DxItem,
  DxScrolling,
  DxButton as DxButtonDatagrid,
  DxSummary,
  DxTotalItem,
  DxHeaderFilter,
  DxRequiredRule,
  DxButton as DxButtonDataGrid,
} from "devextreme-vue/data-grid";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";
import DxTextBox from "devextreme-vue/text-box";
import DxDateBox from "devextreme-vue/date-box";
/* eslint-disable */
export default {
  components: {
    LogPopupTemplate,
    confirm,
    DxTextBox,
    DxDateBox,
    DxDataGrid,
    // eslint-disable-next-line
    DxColumn,
    DxPager,
    DxPaging,
    DxEditing,
    DxFilterRow,
    // eslint-disable-next-line
    DxLookup,
    DxColumnFixing,
    // DxSelection,
    DxExport,
    DxToolbar,
    DxButton,
    DxButtonDatagrid,
    DxItem,
    DxDropDownButton,

    DxSummary,
    DxTotalItem,
    DxScrolling,
    DxHeaderFilter,
    DxRequiredRule,
    DxButtonDataGrid,
  },
  setup() {
    const liburListStore = useLiburListStore();
    liburListStore.dataSourceLiburList.filter(null);
    const commonStore = useCommonStore();

    return {
      liburListStore,
      commonStore,
      commonFunction,
    };
  },
  data() {
    const vm = this;
    return {
      logPopupRef: null,
      dxEditingMode: "popup", //row

      stylingMode: "filled",
      //outlined, filled, underlined
      labelMode: "floating",

      numberingPageSize: 100,
    };
  },

  async created() {
    await this.commonStore.preloadStores();
  },

  async mounted() {},

  computed: {
    gridHeight() {
      // Calculate grid height based on your requirements
      return "80vh"; // Set the height to fill the viewport vertically
    },
  },

  methods: {
    can,
    showData(data) {
      console.log("showData", data);
      // return data.simpeg_pegawais_nama;
    },

    allowUpdate(a, b) {
      if (a || b) return true;
      else return false;
    },
    initNewRow(e) {
      e.data.created_by_user_id = auth.getUser().id;
    },
    onUpdating(e) {
      e.newData.updated_by_user_id = auth.getUser().id;
    },

    onItemClick(e, data) {
      console.log("onItemClick e", e);
      console.log("onItemClick data", data);
      let pegawaiId = data.pegawai_id;

      if (e.itemData === "Absensi") {
        const url = this.$router.resolve({
          name: "absen-list-custom",
          query: { filter: ["absen_bulans_pegawai_id", "=", pegawaiId] },
        }).href;
        window.open(url, "_blank");
      }

      if (e.itemData === "Riwayat Gaji") {
        const url = this.$router.resolve({
          name: "gaji-history-custom",
          query: { filter: ["gajis_pegawai_id", "=", pegawaiId] },
        }).href;
        window.open(url, "_blank");
      }

      if (e.itemData === "Detail Pegawai") {
        const url = this.$router.resolve({
          name: "pegawai-detail-custom",
          query: { id: pegawaiId },
        }).href;
        window.open(url, "_blank");
      }
    },

    can,

    refreshDatagrid(gridRef) {
      // this.pengajuanListStore.dataSourcePengajuanList.filter(null);
      // this.$refs[gridRef].instance.clearFilter();
      this.$refs[gridRef].instance.getDataSource().reload();
    },

    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Hari Libur");

      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "Daftar Hari Libur.xlsx",
          );
        });
      });
      e.cancel = true;
    },
  },
};
</script>
